(function () {
  if (customElements.get('eterea-scanner')) return;

  class EtereaScanner extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-eis-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-eis-panel]'));
      this.switches = Array.from(this.querySelectorAll('[data-eis-group]'));
      this.statusEl = this.querySelector('[data-eis-status]');
      this.countEl = this.querySelector('[data-eis-count]');
      this.labels = { scanning: this.dataset.scanning || '', done: this.dataset.done || '' };
      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab, true));
        tab.addEventListener('keydown', (e) => this.onKey(e));
      });
      this.switches.forEach((btn) => btn.addEventListener('click', () => this.setGroup(btn.dataset.eisGroup, true)));
      const prev = this.querySelector('[data-eis-prev]');
      const next = this.querySelector('[data-eis-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      const startGroup = this.dataset.group || (this.tabs[0] && this.tabs[0].dataset.group);
      this.setGroup(startGroup, false);
    }

    groupTabs() {
      return this.tabs.filter((t) => t.dataset.group === this.group);
    }

    setGroup(group, animate) {
      if (!this.tabs.some((t) => t.dataset.group === group)) group = this.tabs[0].dataset.group;
      this.group = group;
      this.switches.forEach((btn) => btn.setAttribute('aria-pressed', String(btn.dataset.eisGroup === group)));
      this.tabs.forEach((t) => (t.hidden = t.dataset.group !== group));
      const first = this.groupTabs()[0];
      if (first) this.select(first, animate);
    }

    step(dir) {
      const list = this.groupTabs();
      const i = list.indexOf(this.current);
      const next = list[(i + dir + list.length) % list.length];
      if (next) {
        this.select(next, true);
        next.focus({ preventScroll: true });
      }
    }

    onKey(e) {
      const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      if (keys[e.key]) {
        e.preventDefault();
        this.step(keys[e.key]);
      } else if (e.key === 'Home' || e.key === 'End') {
        e.preventDefault();
        const list = this.groupTabs();
        const t = e.key === 'Home' ? list[0] : list[list.length - 1];
        this.select(t, true);
        t.focus({ preventScroll: true });
      }
    }

    select(tab, animate) {
      this.current = tab;
      this.tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      const id = tab.getAttribute('aria-controls');
      this.panels.forEach((p) => (p.hidden = p.id !== id));

      const list = this.groupTabs();
      if (this.countEl) {
        const pad = (n) => String(n).padStart(2, '0');
        this.countEl.textContent = pad(list.indexOf(tab) + 1) + ' / ' + pad(list.length);
      }
      if (tab.scrollIntoView && animate) {
        const strip = tab.parentElement;
        if (strip && strip.scrollWidth > strip.clientWidth) {
          strip.scrollTo({ left: tab.offsetLeft - strip.clientWidth / 2 + tab.clientWidth / 2, behavior: 'smooth' });
        }
      }
      if (!animate) return;
      clearTimeout(this.timer);
      this.classList.remove('is-scanning');
      void this.offsetWidth;
      this.classList.add('is-scanning');
      if (this.statusEl) this.statusEl.textContent = this.labels.scanning;
      this.timer = setTimeout(() => {
        this.classList.remove('is-scanning');
        if (this.statusEl) this.statusEl.textContent = this.labels.done;
      }, 1100);
    }
  }

  customElements.define('eterea-scanner', EtereaScanner);
})();
